import { ReactNode, useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import ManagerSidebar from "./ManagerSidebar";

export default function ManagerLayout({ children }: { children: ReactNode }) {
  const isMobile = useIsMobile();
  const [sheetOpen, setSheetOpen] = useState(false);

  if (!isMobile) {
    return (
      <div className="flex min-h-screen bg-background">
        <ManagerSidebar />
        <main className="flex-1 px-8 py-6">
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 flex items-center gap-3 border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80 px-4 h-14">
        <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="shrink-0">
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-60">
            <ManagerSidebar onNavigate={() => setSheetOpen(false)} />
          </SheetContent>
        </Sheet>
        <span className="text-sm font-semibold">Manager</span>
      </header>
      <main className="px-4 py-4">
        {children}
      </main>
    </div>
  );
}
